import _default from './OverviewAccordion.webpack';

export default _default;
